import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PrivateContainer } from 'containers/PrivateContainer';
import { PublicContainer } from 'containers/PublicContainer';
import { RouteKey, RouteConfigs, RouteKeys } from 'config/routes';

import Login from 'pages/Login/Login';
import Report from 'pages/Report/Report';
import MDReport from 'pages/MDReports/MDReport';
import Parts from 'pages/Parts/Parts';
import Createpart from 'pages/Createpart/Createpart';
import Brands from 'pages/Brands/Brands';
import Users from 'pages/Users/Users';
import country_of_origin from 'pages/Users/UserRegions';
import Editpart from 'pages/Editpart/Editpart';
import UserDetails from 'pages/Userdetails/Userdetails';
import LanguageInfo from 'pages/Language/Langauge';
import Recycle from 'pages/Recycle/Recycle';
import StaticAsset from 'pages/StaticAsset';

import './App.scss';

export const components: { [key in RouteKey]: React.ComponentType<any> } = {
  home: MDReport,
  report: Report,
  login: Login,
  index: Parts,
  addpart: Createpart,
  brands: Brands,
  users: Users,
  country_of_origin: country_of_origin,
  editpart: Editpart,
  userDetail: UserDetails,
  languages: LanguageInfo,
  recycle: Recycle,
  staticAsset: StaticAsset,
};

export const App: React.FC = () => {
  return (
    <div className="fullScreen">
      <Router>
        <Routes>
          {RouteKeys.map((key) => {
            const config = RouteConfigs[key];

            if (config.isStatic) 
              return <Route {...config} key={key} />;

            const SelectedRoute = config.isPrivate ? PrivateContainer : PublicContainer;
            const props = {...config, component: components[key]}
            return <Route path={config.path} element={<SelectedRoute {...props} />} key={key} />;
          })}
        </Routes>
      </Router>
    </div>
  );
};